module.exports = __webpack_public_path__ + "img/icon-back-to-top-hover.70ef61c5.svg";